<template>
    <div
        class="fixed hidden bottom-0 left-0 z-30 w-full py-3 bg-white border-t border-gp-grey-40 no-print max-lg:block">
        <div class="container max-md:px-3.75 grid h-full max-w-lg grid-cols-3 mx-auto">
            <router-link class="icon-nav text-xss" :to="{ name: 'foodCategories' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconGrid></IconGrid>
                    {{ $t('nav.menu') }}

                </div>
            </router-link>
            <router-link class="icon-nav text-xss" :to="{ name: 'foodRestaurants' }">
                <div class="flex flex-col gap-1 items-center">
                    <IconBrand></IconBrand>
                  
                    {{ $t('nav.restaurants') }}
                </div>
            </router-link>

            <router-link class="icon-nav text-xss relative" :to="{ name: 'foodCart' }">
               
                <div class="flex flex-col gap-1 items-center">
                    <IconCart></IconCart>
                    {{ $t('nav.cart') }}
                </div>
            </router-link>

     

            <!-- <router-link class="icon-nav text-xss" to="/">
                <div class="flex flex-col gap-1 items-center">
                    <IconUser></IconUser>
                    {{ $t('nav.profile') }}
                </div>
            </router-link> -->

        </div>
    </div>
</template>

<script setup>
import IconGrid from '@icons/IconGrid.vue'
import IconStore from '@icons/IconStore.vue'
import IconUser from '@icons/IconUser.vue'
import IconCart from '@icons/IconCart.vue'
import IconBrand from '@icons/IconBrand.vue'
</script>

<style>

</style>

<style scoped>
.router-link-exact-active{
    color: #409DBA;
}

</style>